var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaleway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6809 6.96139H9.61812C8.9461 7.03911 8.42917 7.59607 8.40332 8.26961V12.6994C8.40332 12.9973 8.51964 13.2564 8.71349 13.4507C8.90733 13.645 9.1658 13.7615 9.46304 13.7615C10.0446 13.7615 10.5228 13.2823 10.5228 12.6994V9.88869C10.5228 9.4483 10.8846 9.08562 11.324 9.08562H12.7068C13.004 9.08562 13.2625 8.96905 13.4563 8.77476C13.6502 8.58048 13.7665 8.30847 13.7665 8.01056C13.7665 7.42769 13.2625 6.96139 12.6809 6.96139Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2982 17.0645H14.361C15.033 16.9867 15.55 16.4298 15.5758 15.7563V11.3265C15.5758 11.0285 15.4595 10.7695 15.2657 10.5752C15.0718 10.3809 14.8133 10.2643 14.5161 10.2643C13.9346 10.2643 13.4564 10.7436 13.4564 11.3265V14.1372C13.4564 14.5776 13.0945 14.9402 12.6551 14.9402H11.2724C10.9751 14.9402 10.7167 15.0568 10.5228 15.2511C10.329 15.4454 10.2126 15.7174 10.2126 16.0153C10.2256 16.5982 10.7167 17.0645 11.2982 17.0645Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62793 2.7H13.1979C16.8681 2.7 19.8275 5.66616 19.8147 9.34471V18.1655C19.6466 19.8364 18.2896 21.1575 16.6096 21.3H10.7425C7.08515 21.3 4.11279 18.3209 4.11279 14.6553V6.22312C4.11279 4.28023 5.68944 2.7 7.62793 2.7ZM17.7081 9.34471C17.7081 6.8578 15.6792 4.82424 13.1979 4.82424H7.64085C6.86545 4.82424 6.24514 5.44597 6.24514 6.22312V14.6553C6.24514 17.1552 8.26117 19.1757 10.7554 19.1757H16.5192C17.1266 19.0981 17.6048 18.6318 17.7081 18.036V9.34471Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleway);
export default __webpack_public_path__ + "static/media/scaleway.3f209c430052d9943a28d3aaf186c63a.svg";
export { ForwardRef as ReactComponent };